module.exports = __webpack_public_path__ + "static/media/snake-transparent.d716eb2d.png";